import { Icon } from "@iconify/react";

type Props = {
  size?: number;
  className?: string;
};

export function TornihaasteMark({ size = 32, className }: Props) {
  return (
    <span
      className={
        "inline-flex items-center justify-center rounded-[10px] bg-gradient-to-br from-[var(--gold)] to-[var(--gold-dark)] " +
        "border-2 border-[var(--gold-light)] shadow-[0_4px_12px_rgba(184,134,11,0.3)] " +
        (className ?? "")
      }
      style={{ width: size, height: size }}
      aria-hidden="true"
    >
      <Icon
        icon="game-icons:stone-tower"
        className="text-[var(--bg-deep)]"
        style={{ width: size * 0.66, height: size * 0.66 }}
      />
    </span>
  );
}
